import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Document } from './Document'
import { useFetchDocuments } from './useFetchDocuments'

const InspectionAppraisalAndIdentityProof: FC<{
  applicationId: string
}> = ({ applicationId }) => {
  const { t } = useTranslation(['assignments'])
  const data = useFetchDocuments(applicationId)

  return (
    <>
      <p>
        <b>{t('card.loan-info.inspection')} -</b>{' '}
        <Document state={data?.inspectionAppraisal} />
      </p>
      <p>
        <b>{t('card.loan-info.personal-document')} -</b>{' '}
        <Document state={data?.identityProof} />
      </p>
    </>
  )
}

export { InspectionAppraisalAndIdentityProof }
